import { GRS_PERSONALIZATION_LOCAL_STORAGE_KEY } from '@/src/constants';
import {
    useQueryParams,
    useSessionStorage,
} from '@nxt-costco-com/forge-digital-components';

const useGrsPersonalization = () => {
    const { queryParams: searchParams } = useQueryParams();
    const [grsPersonalizationSessionParam, setGRSPersonalizationSessionParam] =
        useSessionStorage(GRS_PERSONALIZATION_LOCAL_STORAGE_KEY, 'false');
    const isGRSPersonalizationEnabled =
        grsPersonalizationSessionParam === 'true' || searchParams.has('grs');

    if (
        isGRSPersonalizationEnabled &&
        grsPersonalizationSessionParam !== 'true'
    ) {
        // Handle the case where GRS personalization is enabled but not set in session storage
        setGRSPersonalizationSessionParam('true');
    }

    return isGRSPersonalizationEnabled;
};

export default useGrsPersonalization;
